export const SidebarVariant = {
  Light: 'light',
  OnBrand: 'onBrand',
} as const;

export type SidebarVariantType =
  (typeof SidebarVariant)[keyof typeof SidebarVariant];

export type SidebarProps = {
  poweredByLabel?: string;
  expandLabel?: string;
  collapseLabel?: string;
  collapsible?: boolean;
  variant?: SidebarVariantType;
  updateAvailable?: boolean;
};
